import styled from 'styled-components';
import { theme } from '../../../theme';

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 7.692rem;
  padding: 0.615rem 1.078rem;
  font-size: 0.923rem;
  line-height: 1.5;
  font-weight: 500;
  text-align: left;
  border-radius: 5px;
  border: 1px solid ${theme.colors.secondary};
  color: ${theme.colors.textPrimary};
  background-color: ${theme.colors.white};
  outline: none;
  resize: none;

  &:hover,
  &:active,
  &:focus {
    box-shadow: none !important;
    border: 1px solid ${theme.colors.secondary} !important;
    color: ${theme.colors.textPrimary} !important;
    background-color: ${theme.colors.white} !important;
  }

  &::placeholder,
  &::-webkit-input-placeholder {
    color: ${theme.colors.textDeaccent};
    font-weight: 500;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${theme.filters.scrollbarTrack};
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.secondary};
    border-radius: 5px;
    outline: none;
  }
`;
